import { NO_DATE } from '@/pages/opinion/constants';
import moment from 'moment';
import React from 'react';
import { useIntl } from 'umi';

export default function ReleaseRow({
  isShadow,
  games,
}: {
  isShadow: boolean;
  games: Array<any>;
}) {
  const { formatMessage } = useIntl();

  const calcReleaseDays = (item: any) => {
    const releaseDays = item?.release_time
      ? moment(item?.release_time).format('YYYY-MM-DD')
      : '';
    const now = moment(Date.now());
    let number = ''; // 距离上线时间的时间
    let dateStr = ''; // 距离上线时间的时间格式
    if (releaseDays) {
      if (now.diff(moment(releaseDays), 'day') < 1) {
        number = ''; //formatMessage({ id: 'Not Released' });
        dateStr = 'Not Released';
      } else if (
        now.diff(moment(releaseDays), 'day') > 1 &&
        now.diff(moment(releaseDays), 'day') <= 30
      ) {
        number = '30';
        dateStr = 'Days';
      } else {
        number = Math.ceil(now.diff(moment(releaseDays), 'months', true)) + '';
        dateStr = 'Months';
      }
    }

    return [number, dateStr ? formatMessage({ id: dateStr }) : dateStr];
  };

  return (
    <>
      <div className="table-context-item">
        <div className="first-col table-item text-name">
          {formatMessage({ id: 'Release Days' })}
        </div>
        {games.map((e: any, i: any) => {
          const [num, str] = calcReleaseDays(e);
          return (
            <div
              className={`col-padding ${
                i == 0 && isShadow ? 'sticky-text' : ''
              }`}
              key={i}
            >
              {num || str ? (
                <div className="dbo-release">
                  <span className="release-num">{num}</span>
                  <span className="release-text">{str}</span>
                </div>
              ) : (
                <div className="no-data-style">
                  {formatMessage({ id: NO_DATE.SIMPLE })}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="table-context-item">
        <div className="first-col table-item text-name">
          {formatMessage({ id: 'Release Date' })}
        </div>
        {games.map((e: any, i: any) => {
          return (
            <div
              className={`col-padding ${
                i == 0 && isShadow ? 'sticky-text' : ''
              }`}
              key={i}
            >
              {e?.release_time ? (
                <div className="dbo-release-date">
                  {moment(e.release_time).format('YYYY-MM-DD')}
                </div>
              ) : (
                <div className="no-data-style">
                  {formatMessage({ id: NO_DATE.SIMPLE })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}
